import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface profileState {
  IdPicBase64: string | null;
  profilePicBase64: string | null;
}

const initialState: profileState = {
  IdPicBase64: null,
  profilePicBase64: null,
};

const userProfileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setIDPhoto(state, action: PayloadAction<{ base64: string }>) {
      // eslint-disable-next-line no-param-reassign
      state.IdPicBase64 = action.payload.base64;
    },
    setProfilePhoto(state, action: PayloadAction<{ base64: string }>) {
      // eslint-disable-next-line no-param-reassign
      state.profilePicBase64 = action.payload.base64;
    },
    removeIDPhoto(state) {
      // eslint-disable-next-line no-param-reassign
      state.IdPicBase64 = null;
    },
    removeProfilePhoto(state) {
      // eslint-disable-next-line no-param-reassign
      state.profilePicBase64 = null;
    },
  },
});

export const {
  setIDPhoto,
  removeIDPhoto,
  setProfilePhoto,
  removeProfilePhoto,
} = userProfileSlice.actions;
export const userProfileReducer = userProfileSlice.reducer;
